import type { VarianceSort } from "../../api/reports";

import type { GroupMode } from "./types";

export const DELTA_MARKT_TOOLTIP =
  "Abweichung von der Preisreferenz zum Belegdatum: zuerst Schnitt der früheren 12 Monate, sonst 24 Monate, danach die gesamte frühere Historie. Der Beleg selbst, gleichdatierte und spätere Preise zählen nicht. Negativ = unter der Referenz (gut), positiv = über der Referenz. Wird für Mehrkosten und den Schwellwert verwendet.";
export const DELTA_12M_TOOLTIP =
  "Heutige Rückschau: Abweichung vom mengengewichteten Artikelschnitt der letzten 12 Monate. Dieser Analysewert enthält nicht die historische Preisreferenz zum jeweiligen Belegdatum.";
export const DELTA_ALLTIME_TOOLTIP =
  "Heutige Rückschau: Abweichung vom mengengewichteten Schnitt aller je gesehenen Belege. Dieser Analysewert kann spätere Preise enthalten und steuert nicht die Preisprüfung.";
export const SPREAD_12M_TOOLTIP =
  "Preisspanne der letzten 12 Monate für diesen Artikel: (Max − Min) / Min Netto-Preis · 100. Hohe Werte deuten auf inkonsistente Konditionen hin.";

export const GROUP_OPTIONS: { value: GroupMode; label: string }[] = [
  { value: "none", label: "Keine" },
  { value: "manufacturer", label: "Hersteller" },
  { value: "project", label: "Projekt" },
  { value: "delivery_address", label: "Lieferadresse" },
];

export const DONUT_COLORS = [
  "#4e79a7",
  "#e15759",
  "#59a14f",
  "#f28e2b",
  "#b07aa1",
  "#edc948",
  "#76b7b2",
  "#ff9da7",
  "#9c755f",
  "#bab0ac",
];

export const FLAT_SORT_PAIRS: Record<
  "doc_date" | "net_price" | "overpay",
  { asc: VarianceSort; desc: VarianceSort }
> = {
  doc_date: { asc: "doc_date_asc", desc: "doc_date_desc" },
  net_price: { asc: "net_price_asc", desc: "net_price_desc" },
  overpay: { asc: "overpay_asc", desc: "overpay_desc" },
};

export const PAGE_SIZE = 50;
